import logo from './logo.svg';
import './App.css';

import Dashboard from './components/Dashboard'

function App() {

  let configuration={};
  if (process.env.NODE_ENV === 'development') {
    configuration.apiUri = process.env.REACT_APP_API_URI_DEVELOPMENT;
  } else if (process.env.NODE_ENV === 'production') {
    configuration.apiUri = process.env.REACT_APP_API_URI_PRODUCTION;
  }

  return (
    <div className="App">
      
      <Dashboard config={configuration}></Dashboard>


    </div>
  );
}

export default App;
